var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-page startup"},[_c('div',{staticClass:"hotel-btn"},[_c('van-button',{on:{"click":_vm.linkHotelList}},[_vm._v("选择酒店")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }